import App from './App.svelte';
import './compiled.css'

const app = new App({
	target: document.body
});

export default app;